import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/hot', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
            尾巴漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                  ? 'text-primary-500'
                  : scrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-foreground-100 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category/hot"
            className="bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium px-5 py-2 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            开始阅读
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${scrolled ? 'text-foreground-900' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 flex flex-col items-center justify-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-lg font-medium cursor-pointer ${
                location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category/hot"
            className="bg-primary-500 hover:bg-primary-600 text-white text-lg font-medium px-8 py-3 rounded-full cursor-pointer"
          >
            开始阅读
          </Link>
        </div>
      )}
    </nav>
  );
}